import { CircularProgress, styled, Typography } from "@mui/material";

const Wrapper = styled("div")({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  pointerEvents: "none",
  display: "grid",
  placeItems: "center",
});

const Inner = styled("div")({
  display: "grid",
  placeItems: "center",
  gap: "2rem",
});

const Loading = (props: { text?: string }) => {
  return (
    <Wrapper>
      <Inner>
        {props.text && (
          <Typography variant="h3" color="primary">
            {props.text}
          </Typography>
        )}
        <CircularProgress />
      </Inner>
    </Wrapper>
  );
};

export default Loading;
